<template>
    <div>
        <el-row class="ship-card-btn">
            <booking-calendar-filter/>
        </el-row>
        <el-card class="book-calendar-main-kan-style">
            <el-row>
                <booking-calendar-base/>
            </el-row>
        </el-card>
    </div>
</template>
<script>
import BookingCalendarFilter from '@/components/Booking/BookingCalendar/BookingCalendarFilter.vue'
import BookingCalendarBase from '@/components/Booking/BookingCalendar/BookingCalendarBase.vue'

export default {
    name: 'ShipFlowBase',
    components: {
        'booking-calendar-filter': BookingCalendarFilter,
        'booking-calendar-base': BookingCalendarBase
    }
}
</script>
<style lang="scss">
    .book-calendar-main-kan-style{
        height: 800px;
    }
</style>
